import { combineReducers } from 'redux';

import analytics from './analytics.reducer';
import capturePolicy from './capturePolicy.reducer';
import changeRequest from './changeRequest.reducer';
import concession from './concession.reducer';
import criteria from './criteria.reducer';
import deskStatus from './deskStatus.reducer';
import executions from './executions.reducer';
import feedPulls from './feedPulls.reducer';
import freddieConnection from './freddieConnection.reducer';
import guardrail from './guardrail.reducer';
import plans from './plans.reducer';
import preview from './preview.reducer';
import priceSourceMatrices from './priceSourceMatrices.reducer';
import priceSources from './priceSources.reducer';
import priceSourceUploads from './priceSourceUploads.reducer';
import pricingCalendar from './pricingCalendar.reducer';
import programCatalog from './programCatalog.reducer';
import schema from './schema.reducer';
import surveillance from './surveillance.reducer';

const reducer = {
  marginCenter: combineReducers({
    analytics,
    capturePolicy,
    changeRequest,
    concession,
    criteria,
    deskStatus,
    executions,
    feedPulls,
    freddieConnection,
    guardrail,
    plans,
    preview,
    priceSourceMatrices,
    priceSources,
    priceSourceUploads,
    pricingCalendar,
    programCatalog,
    schema,
    surveillance,
  }),
};

export default reducer;
